<template>
    <div v-if="isLoaded">
        <div class="content-body"
             v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card"
                         style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour"
                                    :steps="steps"
                                    :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Processo</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()"
                                           v-b-tooltip
                                           title="Cadastrar"><i class="ft-plus"
                                               v-if="getPermission('bprocesso.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)"
                                           v-b-tooltip
                                           title="Ativar Registros"
                                           v-if="getPermission('bprocesso.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)"
                                           v-b-tooltip
                                           title="Inativar Registros"
                                           v-if="getPermission('bprocesso.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Expande a tela"
                                           v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Minimiza a tela"
                                           v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()"
                                           v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                              api-url="/api/bprocesso"
                                              :fields="fields"
                                              :css="css"
                                              :append-params="moreParams"
                                              track-by="bprocesso_id"
                                              pagination-path=""
                                              @vuetable:load-error="onError"
                                              @vuetable:pagination-data="onPaginationData"
                                              @vuetable:loaded="onLoaded">
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          </template>

                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermission('bprocesso.update')"><i class="fa fa-edit"></i></a>
                                                <span v-if="getPermission('bprocesso.status')">
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                    <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                </span>
                                              </button>
                                            </div>
                                          </template>
                                      </vuetable>
                                </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModal"
                     @ok="handleOk">

         <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
           <div v-if="this.modal_acao == 'u'">
             <b-form-text>Código</b-form-text>
             <b-form-input type="text"
                           placeholder="Código"
                           v-model="form.cd"
                           name="cd"
                           >
             </b-form-input>
             <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
           </div>

             <b-form-text>Descrição</b-form-text>
             <b-form-input type="text"
                           placeholder="Descrição"
                           v-model="form.descr"
                           name="descr"
                           >
             </b-form-input>
             <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

             <b-form-text>Nome</b-form-text>
             <b-form-input type="text"
                           placeholder="Nome"
                           v-model="form.nome"
                           name="nome"
                           >
             </b-form-input>
             <b-form-feedback v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

             <b-form-text>Status</b-form-text>
             <multiselect v-model="form.status"
             :options="optionsLivStatus"
             track-by="value"
             label="label"
             :hide-selected="true"
             placeholder="Selecione"
             tag-placeholder="Selecionar"
             select-label="Selecionar"
             selected-label="Selecionado"
             deselect-label="Remover"
             ></multiselect>
             <b-form-feedback v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>

         </form>
                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="showModal=false" variant="secondary">
                             Fechar
                           </b-btn>
                           <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                             Enviar
                           </b-btn>
                       </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import Vuetable from '../components/Vuetable'
    import VuetablePagination from '../components/VuetablePagination'
    import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
    import BProcessoFilterBar from './BProcessoFilterBar'

    export default {
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            'vuetable-filterbar': BProcessoFilterBar
        },
        data() {
            return {
                dataExport: [],
                modal_titulo: '',
                modal_botao: '',
                modal_acao: '',
                loading: false,
                isDisabled: false,
                loadingData: true,
                showModal: false,
                isFullscreen: false,
                optionsLivStatus: [],
                form: new Form({
                    cd: '',
                    nome: '',
                    bprocesso_id: '',
                    descr: '',
                    status: []
                }),
                helpForm: new Form({
                    statusRecord: [],
                    params: []
                }),
                fields: [{
                        name: '__checkbox',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    },
                    {
                        name: 'cd',
                        title: 'Código',
                        sortField: 'cd'
                    },
                    {
                        name: 'descr',
                        title: 'Apólice',
                        sortField: 'descr'
                    },
                    {
                        name: 'nome',
                        title: 'Nome',
                        sortField: 'nome'
                    },
                    {
                        name: '__slot:status',
                        title: 'Status',
                        sortField: 'status'
                    },
                    {
                        name: '__slot:actions', // <----
                        title: 'Ações',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    }
                ],
                css: {
                    loadingClass: 'loading',
                    ascendingIcon: 'glyphicon glyphicon-chevron-up',
                    descendingIcon: 'glyphicon glyphicon-chevron-down',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                },
                moreParams: {}
            }
        },
        mounted() {
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset', e => this.onFilterReset());
            this.getLivStatus();
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            onFilterSet(data_filter) {
                this.loadingData = true;
                this.moreParams = {
                    'cd': data_filter.cd,
                    'nome': data_filter.nome,
                    'descr': data_filter.descr,
                    'status': data_filter.status.value
                }
                Vue.nextTick(() => {
                    this.$refs.vuetable.refresh();
                })
            },
            onFilterReset() {
                this.loadingData = true;
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterShowHide() {
                if (this.vuetableFilterRow) {
                    this.$store.commit('setVuetableFilterRow', false);
                } else {
                    this.$store.commit('setVuetableFilterRow', true);
                }
            },
            onLoaded: function() {
                this.dataExport = this.$refs.vuetable.tableData;
                this.loadingData = false;
                this.$store.commit('setVuetableFilterButton', false);
            },
            handleOk(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStore();
                } else {
                    this.onUpdate(this.form.bprocesso_id);
                }
            },
            onCreate() {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar";
                this.modal_botao = "Cadastrar";
                this.modal_acao = "i";
                this.form.reset();
                this.$refs.modal_form.show();
            },
            onEdit(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar";
                this.modal_botao = "Alterar";
                this.modal_acao = "u";
                this.form.reset();
                this.form.cd = data.cd;
                this.form.descr = data.descr;
                this.form.nome = data.nome;
                this.form.status = {
                    label: data.status.descr,
                    value: data.status.valor
                };
                this.form.bprocesso_id = data.bprocesso_id;
                this.$refs.modal_form.show();
            },
            onStore() {
                this.loading = true;
                this.isDisabled = true;
                this.form.post('/api/bprocesso/store').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdate(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form.post('/api/bprocesso/update/' + id).then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            getLivStatus() {
                this.helpForm.params = {
                    tabela: 'b_processo',
                    coluna: 'status'
                };

                this.helpForm.get('/api/listitemvalor/jsonlist').then(response => {
                        new ReturnApi(response, this, true, false, false);
                        response.items.forEach((obj) => {
                            this.optionsLivStatus.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onActivateDesactivate(action, data, tipo) {
                // Tipo = true = Checkbox
                if (tipo) {
                    this.helpForm.statusRecord = [];
                    this.helpForm.statusRecord.push({
                        id: data.bprocesso_id,
                        status: action
                    });
                } else {
                    this.helpForm.statusRecord = [];
                    this.$refs.vuetable.selectedTo.forEach((obj) => {
                        this.helpForm.statusRecord.push({
                            id: obj,
                            status: action
                        })
                    });
                }

                this.helpForm.post('/api/bprocesso/status').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });

            },
            onError(response) {
                new ReturnApi(response.response, this, true, true, false);
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
        },
        computed: {
            vuetableFilterRow: {
                get() {
                    return this.$store.state.vuetable.filterRow;
                },
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            }
        }
    }

</script>
